/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

/**
 * @description Успешно
 */
export const getApiTestAuthorization200Schema = z.unknown()

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTestAuthorization400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTestAuthorization401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTestAuthorization403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTestAuthorization500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTestAuthorizationQueryResponseSchema = z.lazy(() => getApiTestAuthorization200Schema)